export default "__VITE_ASSET__DIMU5Cmx__"